export default "__VITE_ASSET__e9805d11__"